const teamImages = [
  'images/team/rahul_stonked.png',
  'images/team/adeesh_stonked.png',
  'images/team/ashar_stonked.png',
  'images/team/aaryan_stonked.png'
]

export default teamImages
